(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-create-name.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-create-name.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const Button = svs.ui.ReactButton;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const createTeamAsync = svs.arena.service.teamsService.createTeamAsync;
const handleCreateTeamErrorResponseFromServer = svs.arena.pages.teams.errorHandlers.handleCreateTeamErrorResponseFromServer;

const TeamsCreateName = _ref => {
  let setCreatedTeamId = _ref.setCreatedTeamId;
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    teamName = _React$useState2[0],
    setTeamName = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    teamNameError = _React$useState4[0],
    setTeamNameError = _React$useState4[1];
  const _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    teamNameErrorMessage = _React$useState6[0],
    setTeamNameErrorMessage = _React$useState6[1];
  const _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isButtonDisabled = _React$useState8[0],
    setIsButtonDisabled = _React$useState8[1];
  const validate = curTeamName => {
    let isValid = true;
    if (curTeamName !== null && curTeamName !== void 0 && curTeamName.match(/([^A-Za-z0-9-_\sÅÄÖåäö])/g)) {
      setTeamNameErrorMessage('Namnet innehåller otillåtna tecken');
      setTeamNameError(true);
      isValid = false;
    } else if ((curTeamName === null || curTeamName === void 0 ? void 0 : curTeamName.length) > 31) {
      setTeamNameErrorMessage('Namnet är för långt');
      setTeamNameError(true);
      isValid = false;
    }
    return isValid;
  };
  const handleTeamNameChange = e => {
    e.preventDefault();
    setTeamName(e.target.value);
    if (teamNameError) {
      setTeamNameError(false);
      setTeamNameErrorMessage('');
    }
    validate(e.target.value);
    if (e.target.value && e.target.value.length > 0) {
      if (isButtonDisabled) {
        setIsButtonDisabled(false);
      }
    } else {
      setIsButtonDisabled(true);
    }
  };
  const submitForm = async e => {
    var _createResponse$data;
    e.preventDefault();
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    if (!validate(teamName)) {
      return;
    }
    const createResponse = await createTeamAsync({
      syndicateName: teamName
    });
    if (createResponse.error || !((_createResponse$data = createResponse.data) !== null && _createResponse$data !== void 0 && _createResponse$data.syndicateId)) {
      var _createResponse$error;
      svs.arena.logger.debug('*** submitForm createTeamAsync, createResponse.error ', createResponse.error);
      if (((_createResponse$error = createResponse.error) === null || _createResponse$error === void 0 ? void 0 : _createResponse$error.code) === '22 115') {
        setTeamNameErrorMessage('Detta namn är tyvärr redan upptaget');
      }
      handleCreateTeamErrorResponseFromServer(createResponse.error, teamName, setTeamNameError);
      return;
    }
    const track = {
      category: 'spela-tillsammans',
      action: 'new_team',
      opt_label: 'create_team'
    };
    svs.components.analytics.trackEvent(track);
    setCreatedTeamId(createResponse.data.syndicateId);
  };
  return React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(WidgetArea, {
    areaName: "arenaCreateTeamPageHero",
    fallback: React.createElement("div", {
      className: "margin-2 align-center h2"
    }, "V\xE4lj lagnamn och bjud in v\xE4nner!")
  }), React.createElement("div", {
    className: "margin-top-1 f-center"
  }, "N\xE4r du spelar tillsammans med andra h\xE5ller ni den gemensamma dr\xF6mmen vid liv. Och det b\xE4sta med dr\xF6mmar \xE4r att de kan g\xE5 i uppfyllelse."), React.createElement(Form, {
    id: "create-team-form",
    method: "POST",
    onSubmit: submitForm
  }, React.createElement(ControlGroup, {
    errorMessage: teamNameErrorMessage,
    hasError: teamNameError,
    infoMessage: "Till\xE5tna tecken f\xF6r lagnamnet \xE4r bokst\xE4ver, siffror, bindestreck och understreck. Maximalt antal tecken \xE4r 31.",
    v2: true
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "teamName",
    label: "Hitta p\xE5 ett namn f\xF6r ditt nya lag",
    onChange: handleTeamNameChange,
    type: "text",
    value: teamName
  })), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isButtonDisabled,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Skapa lag")));
};
svs.arena.pages.teams.components.TeamsCreateName = TeamsCreateName;

 })(window);